import React, { useState } from 'react';
import MDButton from 'components/MDButton';
import MDModal from 'components/MDModal';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDInput from 'components/MDInput';
import { useAppServices } from 'hook/services';
import { Button, Stack } from '@mui/material';

const EditModal = ({ data, handleRefresh }) => {
  console.log(data, "datadata")
  const AppService = useAppServices();
  const [openEditProduct, setOpenEditProduct] = useState(false);
  const [processing, setProcessing] = useState(false);

  const handleModal = () => {
    setOpenEditProduct(true);
  };

  const closeEditProduct = () => {
    setOpenEditProduct(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setProcessing(true);

    let image_response;
    if (e.target?.image?.files?.length > 0) {
      image_response = await uploadImage({
        file: e.target?.image?.files?.[0],
        desiredPath: `app/logo/image`,
      })
    }

    const payload = {
      _id: data._id,
      name: e.target.name.value,
      description: e.target.description.value,
      image: image_response ? image_response?.response.data : data.image,
      location_id: e.target.location_id.value,
      status: e.target.status.value,
      type: e.target.type.value,
      agent_id: e.target.agent_id.value,
    };

    const { response } = await AppService.agents.update({ payload });

    if (response) {
      setProcessing(false);
      setOpenEditProduct(false);
      handleRefresh();
    }
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  };

  return (
    <>
      <MDButton color="info" variant="contained" onClick={handleModal}>
        Edit
      </MDButton>
      <MDModal open={openEditProduct} onClose={closeEditProduct}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style} encType="multipart/form-data">
            <MDTypography variant="h5" mb={2}>
              Edit Agent
            </MDTypography>
            <MDBox mb={2}>
              <MDTypography variant="button">Agent ID</MDTypography>
              <MDInput label="Agect ID" name="agent_id" fullWidth required defaultValue={data.agent_id} />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput label="Name" name="name" fullWidth required defaultValue={data.name} />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">description</MDTypography>
              <MDInput label="description" name="description" fullWidth defaultValue={data.description} />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">location_id</MDTypography>
              <MDInput label="location_id" name="location_id" fullWidth defaultValue={data.location_id} />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Type</MDTypography>
              <MDInput
                select
                name="type"
                fullWidth
                defaultValue={data.type}
                SelectProps={{ native: true }}
              >
                <option value="levelup">Level Up Marketplace</option>
                <option value="Location">Location</option>
                <option value="Agency">Agency</option>
              </MDInput>
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Status</MDTypography>
              <MDInput
                select
                name="status"
                fullWidth
                defaultValue={data.status}
                SelectProps={{ native: true }}
              >
                <option value="draft">Draft</option>
                <option value="public">Publish</option>
              </MDInput>
            </MDBox>

            <Stack direction="row" alignItems="center" spacing={2}>
              <Button variant="contained" component="label" sx={{ color: '#fff' }}>
                Upload Image +
                <input hidden name="image" type="file" />
              </Button>
            </Stack>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeEditProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Save
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  );
};

export default EditModal;
